/**
 *
 * app actions
 *
 */

import {
    LOAD_APP,
    CLIENT_SIDE_READY,
} from './app-constants';

/**
 * Load the app, this action starts the bootstrap saga
 * @return {object}     An action object with a type of LOAD_APP
 */
export const loadApp = () => ({
    type: LOAD_APP,
});


/**
 * Load the app, this action starts the bootstrap saga
 * @return {object}     An action object with a type of LOAD_APP
 */
export const clientSideReady = () => ({
    type: CLIENT_SIDE_READY,
});
